import { Navigation } from 'navigation';
import { ActionButtons, Button } from 'ui-components';

type Props = {
  couponCode?: string;
  className?: string;
  width?: number;
};

export default function CutNowButton({
  couponCode,
  width,
  className,
  ...props
}: Props): React.ReactElement {
  return (
    <ActionButtons className={className} width={width}>
      <Button as="a" href={Navigation.CUT_NOW_URL(couponCode)} {...props}>
        CUT NOW
      </Button>
    </ActionButtons>
  );
}
